export enum StackDirectionEnum {
  COLUMN = 'column',
  ROW = 'row',
  ROW_REVERSE = 'row-reverse',
  COLUMN_REVERSE = 'column-reverse',
}
